import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import "../css/signupPage.css";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";
import { useGoogleLogin } from "@react-oauth/google";

const SignUpOptions = ({ onEmailClick }) => {
  const appContext = useContext(AppContext);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLoginChange = useGoogleLogin({
    onSuccess: (tokenResponse) => loginWithCode(tokenResponse?.access_token),
    onError: (error) => {
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
    },
  });

  const loginWithCode = async (code) => {
    appContext.updateLoaderState(true);
    try {
      const loginWithGoogle = await axiosHttp.post(`login/google`, {
        token: code,
      });
      if (loginWithGoogle.status === 200) {
        localStorage.setItem(
          "token",
          loginWithGoogle?.data?.success?.token || null
        );
        const userProfile = loginWithGoogle?.data?.userProfile || null;
        if (userProfile?.userId) {
          localStorage.setItem("userId", userProfile.userId);
        }
        login(userProfile);
        // Redirect to dashboard after successful Google login
        navigate("/home", { replace: true });
      } else {
        throw new Error("Login failed");
      }
    } catch (e) {
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
    } finally {
      appContext.updateLoaderState(false);
    }
  };

  return (
    <div className="signup-left">
      <div className="form-content">
        <h1>Create your Upskillmeet account</h1>
        <p>Find people to learn from. Be someone others can learn from.</p>

        <button className="google-btn" onClick={handleLoginChange}>
          <FontAwesomeIcon icon={faGoogle} className="icon" />
          Continue with Google
        </button>

        <div className="divider">
          <span>or</span>
        </div>

        <button className="email-btn" onClick={onEmailClick}>
          Continue with email
        </button>
        <div className="signup-footer">
          <p className="terms">
            Already have an account? <a href="/login">Sign in</a>
            <br />
            Read our <a href="/tnc">Terms</a> and{" "}
            <a href="/privacy-policy">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpOptions;
